import React from 'react';
import { Link } from 'react-router-dom';
import EmptyState from '../components/EmptyState';
import { Search } from 'lucide-react';
import './NotFound.css';

const NotFound = () => {
  return (
    <div className="not-found-container">
      <EmptyState
        icon={<Search size={48} />}
        title="404 - Page Not Found"
        message="The page you're looking for doesn't exist. It may have been moved or deleted."
        actionText="Go to Homepage"
        actionLink="/"
      />
      <div className="not-found-extra-actions">
        <Link to="/jobs" className="btn btn-secondary">
          Browse Jobs
        </Link>
        {' '}
        <Link to="/dashboard" className="btn btn-secondary">
          Go to Dashboard
        </Link>
      </div>
    </div>
  );
};

export default NotFound;
